import request from '@/service/request';

export const getPlanInfo = ({
  productType,
  productId,
  planId,
}: {
  productType: string;
  productId: string;
  planId: string;
}) => {
  return request(
    `/v1/shaft/public/class/ips/vn/${productType}/products/${productId}/plans/${planId}`,
  );
};

export const getPlanCmsDetail = ({
  productType,
  productId,
  planId,
}: {
  productType: string;
  productId: any;
  planId: string;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productId}/plans/cms/${planId}`,
  );
};

export const getQuotation = ({ quotationId }: { quotationId: string }) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/quotes/${quotationId}?id_type=ext_id`,
  );
};

export const getPaymentInfo = ({
  productType,
  applicationId,
}: {
  productType: string;
  applicationId: string;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/applications/${applicationId}/payment`,
  );
};

export const initPayment = (
  productType: string,
  applicationId: string,
  params: any,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/applications/${applicationId}/payment`,
    {
      method: 'post',
      data: params,
      escapeDecamelize: true,
    },
  );
};
